import React from 'react';
import Layout from '../Layout';
import FeedbackFloater from './FeedbackFloater';

interface Props {
  children: React.ReactNode;
}

const LayoutWithFeedback: React.FC<Props> = ({ children }) => {
  return (
    <Layout>
      {children}
      <FeedbackFloater />
    </Layout>
  );
};

export default LayoutWithFeedback;
